export class LoginModel {
  username!: string;
  password!: string;
  client_id!: string;
  client_secret!: string;
}
